import { render, staticRenderFns } from "./VerifyWalletModal.vue?vue&type=template&id=7d09b46e"
import script from "./VerifyWalletModal.vue?vue&type=script&lang=js"
export * from "./VerifyWalletModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports